import React, { useState } from 'react';
import { Checkbox } from './ui/Checkbox';

interface ToReviewCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => Promise<void>;
}

export function ToReviewCheckbox({ checked, onChange }: ToReviewCheckboxProps) {
  const [updating, setUpdating] = useState(false);

  const handleChange = async () => {
    try {
      setUpdating(true);
      await onChange(!checked);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="text-sm bg-gray-200 text-gray-600 px-2 rounded flex items-center h-[26px]">
      <Checkbox
        checked={checked}
        loading={updating}
        label="To Review"
        onClick={handleChange}
        disabled={updating}
        className="text-gray-600 font-normal leading-none"
      />
    </div>
  );
}